import React, { useEffect } from 'react';
import ReactDOM from "react-dom";
import Datamodal from "components/modal/dataModal";
import Modalstructure from "components/modal/components/structure";
import UseContext from "hooks/useContext";
import useModal from "components/modal/useModal";

const Index = () => {
    const { modalShow, openModal, setOpenModal } = UseContext();
    const { toggle } = useModal();

    useEffect(() => {
        if (openModal) {
            toggle(openModal);
            setOpenModal(false);
        }
    }, [openModal]);

    if(!modalShow) return null

    return ReactDOM.createPortal(
        <Modalstructure isShowing={modalShow}>
            <Datamodal/>
        </Modalstructure>
        , document.getElementById('root-portal'));
};

export default Index;